/* eslint-disable no-inner-declarations */
import { styled, useTheme } from '@mui/material/styles';
import TableContainer from '@mui/material/TableContainer';
import useMediaQuery from '@mui/material/useMediaQuery';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import ButtonsField from '../../FMForm/FormTypes/ButtonsField/ButtonsField';
import { uploadingTheFile } from '../../FMForm/FormHelpers/UploadingFile';
import TextInput from '../../FMForm/FormTypes/TextInput/TextInput';
import RadioInput from '../../FMForm/FormTypes/RadioInput/RadioInput';
import SelectInput from '../../FMForm/FormTypes/SelectInput/SelectInput';
import ObjectInput2 from '../../FMForm/FormTypes/ObjectInput/ObjectInput2';
import FileUploadField from '../../FMForm/FormTypes/FileUploadField/FileUploadField';
import SwitchInput from '../../FMForm/FormTypes/SwitchInput/SwitchInput';
import CheckboxInput from '../../FMForm/FormTypes/CheckboxInput/CheckboxInput';
import DateTimeInput from '../../FMForm/FormTypes/DateTimeInput/DateTimeInput';
import LookupInput from '../../FMForm/FormTypes/LookupInput/LookupInput';
import { getFileName } from '../../../../services/FilesService';
import { getAuthData } from '../../../../services/storage/LocalStorage';

const TableMainConatiner = styled(TableContainer)(() => ({
  width: '100%',
  overflow: 'hidden',
  '& .MuiFormControl-root': {
    '& .MuiFormControlLabel-root': { marginBottom: -10 },
  },
}));

const customStyleForCheckbox = { marginLeft: '10px', marginBottom: '10px' };

const FMFilterFieldsComponent = ({
  conversation,
  options,
  handleAction,
  updateRedux,
  showLargeScreen = true,
}) => {
  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [, setDisableSubmit] = useState(true);

  const { filteredColumns: fields, genericError } = useSelector((state) => state.filters);
  const { user: { userTimezone } } = getAuthData();
  const defaultUserTimezone = 'Etc/UTC';

  useEffect(() => {
    if (fields && fields.length) {
      const mandatoryFields = [];
      const isEmptyValues = (value) => value === undefined
        || value === null
        || (typeof value === 'object' && Object.keys(value).length === 0)
        || (typeof value === 'string' && value.length === 0);
      fields.forEach((el, index) => {
        if (
          el.mandatory
          && (isEmptyValues(el.value) || el.validationResult === false)
        ) {
          mandatoryFields.push(index);
        }
      });
      if (
        mandatoryFields.length
        || (genericError && !genericError.validationResult)
      ) {
        setDisableSubmit(true);
      } else {
        setDisableSubmit(false);
      }
    }
  }, [JSON.stringify(fields), genericError]);

  const handleChange = (e, type, val) => {
    fields.forEach((el) => {
      const updatedEl = { ...el };
      if (updatedEl.id === e?.target?.name) {
        switch (type) {
          case 'lookup':
          case 'uploadFile':
            updatedEl.value = val;
            break;
          case 'removeUploadFile':
            delete updatedEl.value;
            break;
          default:
            updatedEl.value = e.target.value;
            break;
        }
        delete updatedEl.validationResult;
        delete updatedEl.validationMessage;
        updateRedux(updatedEl);
      }
    });
  };

  const onBlurField = (e, action = 'move') => {
    fields.forEach((el) => {
      if (el.id === e.target.name) {
        handleAction(action, el.id, e.target.value || '');
      }
    });
  };

  const onSelectField = (id, value = '', action = 'move') => {
    handleAction(action, id, value);
  };

  const handleChangeSwitch = (e) => {
    fields.forEach((el) => {
      const updatedEl = { ...el };
      if (updatedEl.id === e.target.name) {
        updatedEl.value = e.target.checked;
        delete updatedEl.validationResult;
        delete updatedEl.validationMessage;
        updateRedux(updatedEl);
      }
    });
  };

  const handleChangeCheck = (e) => {
    fields.forEach((el) => {
      const updatedEl = { ...el };
      if (updatedEl.id === e.target.id) {
        updatedEl.value = updatedEl.value || [];
        if (updatedEl.value.includes(e.target.name)) {
          updatedEl.value = updatedEl.value.filter((item) => item !== e.target.name);
        } else {
          updatedEl.value.push(e.target.name);
        }
        delete updatedEl.validationResult;
        delete updatedEl.validationMessage;
        updateRedux(updatedEl);
      }
    });
  };

  const handleChangeData = (value, name) => {
    fields.forEach((el) => {
      if (el.id === name) {
        let ipochDate = "";
        ipochDate = moment.utc(value, 'YYYY-MM-DD').unix() * 1000;
        el.value = parseInt(ipochDate);
        el["editingDateTime"] = true;
        delete el.validationResult;
        delete el.validationMessage;

        if (value === null) {
          el.value = '';
          el.valueAsString = '';
        }

        updateRedux(el);
      }
    });
  }

  const handleBlurDate = (value, name) => {
    fields.forEach((el) => {
      if (el.id === name) {
        let ipochDate = "";
        ipochDate = moment.utc(value, 'YYYY-MM-DD').unix() * 1000;
        el.value = parseInt(ipochDate);
        el.valueAsString = moment(value).format("DD/MM/YYYY");
        el["editingDateTime"] = false;
        updateRedux(el);
        handleAction("move", el.id, parseInt(ipochDate));
      }
    });
  };

  const handleChangeDateTime = (value, name) => {
    fields.forEach((el) => {
      const updatedEl = { ...el };
      if (updatedEl.id === name) {
        let ipochDate = '';
        ipochDate = value
          ? moment(value)
            .tz(userTimezone || defaultUserTimezone)
            .format('x')
          : null;
        updatedEl.value = ipochDate ? parseInt(ipochDate, 10) : null;
        delete updatedEl.validationResult;
        delete updatedEl.validationMessage;
        updateRedux(updatedEl);
      }
    });
  };

  const handleBlurDateTime = (value, name) => {
    fields.forEach((el) => {
      const updatedEl = { ...el };
      if (updatedEl.id === name) {
        let ipochDate = '';
        ipochDate = value ? moment(value).utc().format('x') : null;
        updatedEl.value = ipochDate ? parseInt(ipochDate, 10) : null;
        handleAction('move', updatedEl.id, ipochDate ? parseInt(ipochDate, 10) : null);
      }
    });
  };

  const handleClick = (e, type, id, title = null) => {
    e.persist();
    switch (type) {
      case 'button':
        handleAction('click', id, title);
        break;
      case 'uploadFile': {
        const file = e.target.files;
        if (!file) {
          return;
        }
        const fileDetailObj = file[0];
        const fileName = file && file[0] ? file[0].name : '';
        let createFileName = getFileName();
        createFileName += fileName.substr(
          fileName.lastIndexOf('.'),
          fileName.length - 1,
        );
        setIsFileUploading(true);
        uploadingTheFile(fileDetailObj, conversation, createFileName)
          .then((data) => {
            fields.forEach((el) => {
              const updatedEl = { ...el };
              if (updatedEl.id === e.target.name) {
                updatedEl.value = data.split('/').pop();
                updatedEl.fileName = fileName;
                updateRedux(updatedEl);
                handleAction('move', updatedEl.id, updatedEl.value);
              }
            });
            setIsFileUploading(false);
          })
          .catch((err) => {
            console.log('on error === ', err);
            setIsFileUploading(false);
          });
        break;
      }
      case 'removeUploadFile': {
        const custEvent = { target: { name: id } };
        handleChange(custEvent, type);
        setIsFileUploading(false);
        break;
      }
      default:
        break;
    }
  };

  return (
    <TableMainConatiner component='div'>
      {Array.isArray(fields)
        && fields?.map((field) => {
          if (!field.hidden) {
            switch (field.type) {
              case 'text_field':
              case 'number':
              case 'text_area':
                return (
                  <TextInput
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    handleChange={handleChange}
                    onBlurField={onBlurField} />
                );

              case 'radiobutton':
                return (
                  <RadioInput
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    handleChange={handleChange}
                    onBlurField={onBlurField} />
                );

              case 'dropdown': {
                return (
                  <SelectInput
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    multiple={false}
                    handleChange={handleChange}
                    onBlurField={onBlurField} />
                );
              }
              case 'object_dropdown': {
                return (
                  <ObjectInput2
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    multiple={false}
                    handleChange={handleChange}
                    onBlurField={onBlurField} />
                );
              }
              case 'multi_selection':
                return (
                  <SelectInput
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    multiple
                    handleChange={handleChange}
                    onBlurField={onBlurField} />
                );

              case 'file_field':
                return (
                  <FileUploadField
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isFileUploading={isFileUploading}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    handleClick={handleClick} />
                );

              case 'buttons_field':
                return (
                  <ButtonsField
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    handleClick={handleClick} />
                );

              case 'switch':
                return (
                  <SwitchInput
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    handleChangeSwitch={handleChangeSwitch} />
                );
              case 'checkbox':
                return (
                  <div style={customStyleForCheckbox}>
                    <CheckboxInput
                      key={field.id}
                      {...field}
                      readOnly={options?.readOnly ? true : field.readOnly}
                      isSmallScreen={!(showLargeScreen && largeScreen)}
                      handleChangeCheck={handleChangeCheck} />
                  </div>
                );

              case 'date':
              case 'time':
              case 'datetime':
                return (
                  <DateTimeInput
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    handleChangeDateTime={handleChangeDateTime}
                    handleChangeData={handleChangeData}
                    handleBlurDate={handleBlurDate}
                    handleBlurDateTime={handleBlurDateTime} />
                );
              case 'password_field': // TODO
                break;
              case 'slider': // TODO
                break;
              case 'image_field': // TODO
                break;
              case 'lookup':
                return (
                  <LookupInput
                    key={field.id}
                    {...field}
                    readOnly={options?.readOnly ? true : field.readOnly}
                    isSmallScreen={!(showLargeScreen && largeScreen)}
                    handleChange={handleChange}
                    onBlurField={onBlurField}
                    onSelectField={onSelectField} />
                );
              default:
                break;
            }
          }
          return null;
        })}
    </TableMainConatiner>
  );
};

export default React.memo(FMFilterFieldsComponent);
